var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDowcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#373A3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1705,
    y: -1144,
    width: 1892,
    height: 4660,
    fill: "#032339"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1643,
    y: -60,
    width: 1767,
    height: 200,
    rx: 10,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -519.5,
    y: -29.5,
    width: 619,
    height: 139,
    rx: 4.5,
    fill: "#E4F4FF",
    stroke: "#3F76E2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#3F76E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.414 41.413C48.196 40.631 48.196 39.367 47.414 38.585C47.024 38.195 46.512 37.999 46 37.999C45.488 37.999 44.976 38.195 44.586 38.585L42 41.171V25.999C42 24.895 41.106 23.999 40 23.999C38.894 23.999 38 24.895 38 25.999V41.171L35.414 38.585C34.632 37.803 33.368 37.803 32.586 38.585C31.804 39.367 31.804 40.631 32.586 41.413L38.586 47.413C39.368 48.195 40.632 48.195 41.414 47.413L47.414 41.413Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 51.9995C24.8954 51.9995 24 52.895 24 53.9995C24 55.1041 24.8954 55.9995 26 55.9995H54C55.1046 55.9995 56 55.1041 56 53.9995C56 52.895 55.1046 51.9995 54 51.9995H26Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowcard);
export default __webpack_public_path__ + "static/media/dowcard.a25e89cb6ddf438911c30b66f0303424.svg";
export { ForwardRef as ReactComponent };